module.exports = __webpack_public_path__ + "static/media/country_tf.4236ef3c.webp";